import appModule from './app.module';
import angular from 'angular';

var env = {};
// Import variables if present (from env.js)
if (window) {
    angular.copy(window.__env, env);
}

appModule.constant('__env', env);



// WEBPACK FOOTER //
// ./app.env.js